module.exports = __webpack_public_path__ + "img/bg_duoduop_des_3.f6eaf98d.jpg";